import { namespaces } from '@common'

export const namespace = namespaces.shop.value
export const schema = 'shopRewardSchema'
export const backendDocType = 'RewardShop'
export const docPrivilege = 'shop'
